import { UrsaCodeListRequest } from "@/domain/entities/OperationalArea";

export class OperationalAreaEndpoint {
  getUrsaCodeList(params: UrsaCodeListRequest): string {
    return `/geocoding-api/v1/sorting-level-courier/district-operational?${params.toQueryString()}`;
  }

  getUrsaCodeDetail(ursaCode = "") {
    return `geocoding-api/v1/sorting-level-courier/district-operational/${ursaCode}`
  }
}
